export const SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE = 'SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE'
export const SET_IS_USER_BHB_ELIGIBLE = 'SET_IS_USER_BHB_ELIGIBLE'

export const saveHealthPlanSelectionFromTriage = (selectedHealthPlan: $TSFixMe) => {
  return {
    type: SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE,
    selectedHealthPlan,
  }
}
